// Kyle API 对账ID管理 -> 待处理
import request from "@/utils/request";

// 获取待处理 列表
export function getList(data) {
  return request({
    url: "/plWorkOrder/queryReconciliations",
    method: "post",
    data,
  });
}

// 添加/编辑对账ID
export function doEdit(data) {
  return request({
    url: "/plWorkOrder/eidtReconciliationByWorkOrderNo",
    method: "post",
    data,
  });
}

export function doDelete(data) {
  return request({
    url: "/plVerifyTodo/doDelete",
    method: "post",
    data,
  });
}

export function doReturn(data) {
  return request({
    url: "/plVerifyTodo/doReturn",
    method: "post",
    data,
  });
}

export function doCommit(data) {
  return request({
    url: "/plVerifyTodo/doCommit",
    method: "post",
    data,
  });
}
